import { render, staticRenderFns } from "./subject-card.vue?vue&type=template&id=7a8c4b23"
import script from "./subject-card.vue?vue&type=script&lang=js"
export * from "./subject-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports